import { getters } from '/@/modules/core/app/helpers/store';
import { RouteConfig } from '/@/modules/core/app/helpers/RouteConfig';

export class InboxRouteConfig extends RouteConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    const authUser = getters.auth.getUser();
    if (authUser.currentEstate?.isStandardPlan) {
      return authUser.permission.canAccessClearWillInboxPage;
    }

    return authUser.permission.canAccessInbox;
  }
}
